import { http, HttpResponse } from 'msw';

import { apiRoutes } from '@features/campaigns/shared/consts/apiRoutes.ts';
import { mockedCreatableMediaTypes } from '@shared/mocks/requests/creatableMediaTypes/creatableMediaTypes.fixtures.ts';

export const creatableMediaTypesRequests = [
  http.get(`*${apiRoutes.getCreatableMediaTypes()}`, () => {
    return HttpResponse.json(mockedCreatableMediaTypes);
  }),
];
